const DEFAULT_COLOR = '#c00f0f';

function hexColor(value) {
    if (typeof value !== 'string' || !/^#[0-9a-f]{6}$/i.test(value.trim())) return null;
    return value.trim().toLowerCase();
}

function tint(color, white) {
    const channels = [1, 3, 5].map(offset => parseInt(color.slice(offset, offset + 2), 16));
    return '#' + channels.map(channel =>
        Math.round(channel + (255 - channel) * white).toString(16).padStart(2, '0')
    ).join('');
}

function luminance(color) {
    const channels = [1, 3, 5].map(offset => parseInt(color.slice(offset, offset + 2), 16) / 255)
        .map(value => value <= .04045 ? value / 12.92 : ((value + .055) / 1.055) ** 2.4);
    return channels[0] * .2126 + channels[1] * .7152 + channels[2] * .0722;
}

function readableText(color, background) {
    const base = luminance(color), bg = luminance(background);
    if ((Math.max(base, bg) + .05) / (Math.min(base, bg) + .05) >= 4.5) return color;
    return (bg + .05) / .05 >= 4.5 ? '#000000' : '#ffffff';
}

export function promotionBadgeStyle(colors = {}, fallback = DEFAULT_COLOR) {
    const color = hexColor(colors.color) || hexColor(fallback) || DEFAULT_COLOR;
    const backgroundColor = hexColor(colors.background_color) || tint(color, .92);
    return {
        color: readableText(color, backgroundColor),
        backgroundColor,
        borderColor: hexColor(colors.border_color) || tint(color, .75),
    };
}

export function promotionBadgeKind(promotionTitle, {backToSchool, lensCreditTitle} = {}) {
    if (backToSchool?.active && promotionTitle === backToSchool.title) return 'backToSchool';
    if (lensCreditTitle && promotionTitle === lensCreditTitle) return 'lensCredit';
    return 'sale';
}
